// extracted by mini-css-extract-plugin
export default {"siderBottomInfo":"styles_siderBottomInfo__VcbBq","title":"styles_title__E-Wtd","logo":"styles_logo__QvGff","aboutSection":"styles_aboutSection__ds2DY","row":"styles_row__-lOPP"};